export const MODULES_ACTIONS = {
  GET_STATE_FROM_API: 'MODULES/GET_STATE_FROM_API',
  GET_STATE_FROM_API_SUCCESS: 'MODULES/GET_STATE_FROM_API_SUCCESS',
  GET_STATE_FROM_API_FAILURE: 'MODULES/GET_STATE_FROM_API_FAILURE',
  DELETE_ITEM: 'MODULES/DELETE_ITEM',
  DELETE_ITEM_SUCCESS: 'MODULES/DELETE_ITEM_SUCCESS',
  DELETE_ITEM_FAILURE: 'MODULES/DELETE_ITEM_FAILURE',
  CREATE_MODULE: 'MODULES/CREATE_MODULE',
  CREATE_MODULE_SUCCESS: 'MODULES/CREATE_MODULE_SUCCESS',
  CREATE_MODULE_FAILURE: 'MODULES/CREATE_MODULE_FAILURE',
  UPDATE_MODULE: 'MODULES/UPDATE_MODULE',
  UPDATE_MODULE_SUCCESS: 'MODULES/UPDATE_MODULE_SUCCESS',
  UPDATE_MODULE_FAILURE: 'MODULES/UPDATE_MODULE_FAILURE',
  SET_MODULE_TO_EDIT: 'MODULES/SET_MODULE_TO_EDIT',
  SET_MODULE_TO_DELETE: 'MODULES/SET_MODULE_TO_DELETE',
  OPEN_CREATION_FORM: 'MODULES/OPEN_CREATION_FORM',
  CLOSE_CREATION_FORM: 'MODULES/CLOSE_CREATION_FORM',
};

const initialState = {
  modules: [],
  loading: false,
  error: null,
  deleteLoading: false,
  deleteError: null,
  createModuleLoading: false,
  updateModuleLoading: false,
  moduleToEdit: null,
  moduleToDelete: null,
  creationFormOpen: false,
};

export const modulesReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case MODULES_ACTIONS.GET_STATE_FROM_API:
      return {
        ...state,
        loading: true,
      };
    case MODULES_ACTIONS.GET_STATE_FROM_API_SUCCESS:
      return {
        ...state,
        loading: false,
        modules: action.payload,
      };
    case MODULES_ACTIONS.GET_STATE_FROM_API_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case MODULES_ACTIONS.DELETE_ITEM:
      return {
        ...state,
        deleteLoading: true,
      };
    case MODULES_ACTIONS.DELETE_ITEM_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        moduleToDelete: null,
        modules: state.modules.filter((module) => module.id !== action.payload.id),
      };
    case MODULES_ACTIONS.DELETE_ITEM_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.payload.message,
      };
    case MODULES_ACTIONS.CREATE_MODULE:
      return {
        ...state,
        createModuleLoading: true,
      };
    case MODULES_ACTIONS.CREATE_MODULE_SUCCESS:
      return {
        ...state,
        createModuleLoading: false,
        modules: [...state.modules, action.payload],
      };
    case MODULES_ACTIONS.CREATE_MODULE_FAILURE:
      return {
        ...state,
        createModuleLoading: false,
      };
    case MODULES_ACTIONS.UPDATE_MODULE:
      return {
        ...state,
        updateModuleLoading: true,
      };
    case MODULES_ACTIONS.UPDATE_MODULE_SUCCESS:
      return {
        ...state,
        updateModuleLoading: false,
        modules: state.modules.map((module) =>
          module.id === action.payload.id ? action.payload : module,
        ),
      };
    case MODULES_ACTIONS.UPDATE_MODULE_FAILURE:
      return {
        ...state,
        updateModuleLoading: false,
      };
    case MODULES_ACTIONS.SET_MODULE_TO_DELETE:
      return {
        ...state,
        moduleToDelete: action.payload.module,
      };
    case MODULES_ACTIONS.OPEN_CREATION_FORM:
      return {
        ...state,
        creationFormOpen: true,
        moduleToEdit: action.payload.module,
      };
    case MODULES_ACTIONS.CLOSE_CREATION_FORM:
      return {
        ...state,
        creationFormOpen: false,
        moduleToEdit: null,
      };
    default:
      return state;
  }
};
